// extracted by mini-css-extract-plugin
module.exports =  {"viewContainer":"viewContainer_NoAUYZqH"};